export class SearchDocument {
    companyRuc: string;
    documentType: string;
    issueDate: string;
    serie: string;
    number: string;
    downloadLink: string;
  };